// extracted by mini-css-extract-plugin
export default {"wrapper":"Docs_wrapper_uMijY","docCard":"Docs_docCard_x6DS5","cardLeft":"Docs_cardLeft_z3FhE","iconWrap":"Docs_iconWrap_ZuUSP","chev":"Docs_chev_qAaRN"};